import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Divider from '../Divider';
import Link from '../Link';
import TranslationProvider from '../../providers/TranslationProvider';
import ArrowUpRight from '../../svg/icons/arrow-up-right.svg';
import TockLogo from '../../svg/logos/tock-logo.svg';

import './TockReservationsNotice.scss';

const DEFAULT_TOCK_URL = 'https://www.exploretock.com';
const TOCK_RESERVATIONS_PATH = '/profile/reservations/upcoming';

const getTockReservationsUrl = (tockBaseUrl) => {
  const normalizedBaseUrl = (tockBaseUrl || DEFAULT_TOCK_URL).replace(/\/$/, '');
  return `${normalizedBaseUrl}${TOCK_RESERVATIONS_PATH}`;
};

const TockReservationsNotice = ({ tockBaseUrl }) => (
  <div className="TockReservationsNotice">
    <p className="TockReservationsNotice__headline">
      <TranslationProvider translationKey="tock_reservations_notice_headline">
        <strong>Missing a Reservation?</strong>
      </TranslationProvider>
    </p>

    <p className="TockReservationsNotice__body">
      <TranslationProvider translationKey="tock_reservations_notice_body">
        <span>If you booked through Tock, your reservation won&apos;t appear here. Check your confirmation email or manage your reservation directly on Tock.</span>
      </TranslationProvider>
      {' '}
      <Link
        className="TockReservationsNotice__link"
        href={getTockReservationsUrl(tockBaseUrl)}
        target="_blank"
        rel="noopener"
      >
        <TranslationProvider translationKey="tock_reservations_notice_link">
          <span>Go to ExploreTock.com</span>
        </TranslationProvider>
        <ArrowUpRight className="TockReservationsNotice__linkIcon" aria-hidden="true" />
      </Link>
    </p>

    <Divider marginVertical={10} />

    <div className="TockReservationsNotice__badge">
      <TockLogo
        className="TockReservationsNotice__badgeLogo"
        role="img"
        aria-label="Tock"
        focusable="false"
      />
      <TranslationProvider translationKey="tock_reservations_notice_badge">
        <span className="TockReservationsNotice__badgeText">
          Now part of the Resy Network
        </span>
      </TranslationProvider>
    </div>
  </div>
);

TockReservationsNotice.propTypes = {
  tockBaseUrl: PropTypes.string,
};

TockReservationsNotice.defaultProps = {
  tockBaseUrl: undefined,
};

TockReservationsNotice.displayName = 'TockReservationsNotice';

const mapStateToProps = (state) => ({
  tockBaseUrl: state.resyCore?.serviceConfigMap?.tock?.baseUrl,
});

export { TockReservationsNotice as ComponentUnderTest };
export default connect(mapStateToProps)(TockReservationsNotice);
